function Form() {
    const reset = (e) => {
        document.getElementById("dialog").close();
    }

    return (
        <form onReset={reset}>
            <h2>Запись на курс</h2>
            <p>Можете написать мне в социальных сетях, чтобы записаться на курс:</p>
            <p>+7(950)386-61-02</p>
            <p style={{color : "gray"}}>Viber, Telegram, WhatsApp</p>
            <input type="reset" value="Назад"/><br/>
        </form>
    )
}

export default Form;